import { EmailDigestAddonCard } from './EmailDigestAddonCard.js'
import { EmailNotificationSettings } from './EmailNotificationSettings.js'
import { FromEmailSettings } from './FromEmailSettings.js'

export const Notifications = () => {
  return (
    <div className="max-w-3xl flex-col space-y-5">
      <EmailNotificationSettings />
      <EmailDigestAddonCard />
      <FromEmailSettings />
    </div>
  )
}
